import { render } from "./GenerateUrlTable.vue?vue&type=template&id=5d628cf0&scoped=true"
import script from "./GenerateUrlTable.vue?vue&type=script&lang=ts"
export * from "./GenerateUrlTable.vue?vue&type=script&lang=ts"

import "./GenerateUrlTable.vue?vue&type=style&index=0&id=5d628cf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d628cf0"

export default script